import DefaultImg from "../../../assets/img/default-image.svg";
import { EARLY_CHILDHOOD_EDUCATION } from "../../../models/Onboarding/onboarding-values";
import { IReferralCandidate } from "../../../store/superadmin/referral/types";
import { getEnumValue } from "../../../utils/dataParser";
import { capitalizeName } from "../../../utils/stringUtils";
import RefereeItem from "./RefereeItem";

interface IReferralCardProps {
  referrer: IReferralCandidate;
  referrerCount: number;
  onRefereeClick: (uuid:string, id: number) => void;
}

const ReferralCard = ({
  referrer,
  referrerCount,
  onRefereeClick,
}: IReferralCardProps) => {
  return (
    <div
      className={`${
        referrerCount > 1 ? "border-bottom border-off-white" : ""
      } p-15px d-flex flex-column flex-lg-row gap-20 align-items-lg-center`}
    >
      <div className="w-50px h-50px radius-50px">
        <img
          src={DefaultImg}
          alt="default"
          width={"50px"}
          height={"50px"}
          className="img-responsive rounded-circle object-fit-cover"
        />
      </div>
      <div className="d-flex flex-column gap-3 w-170px text-break">
        <div className="fs-16 fw-700 text-black">
          {capitalizeName(referrer?.first_name ?? "")} {capitalizeName(referrer?.last_name ?? "")}
        </div>
        <div className="fs-13 fw-400 text-black">
          { referrer.candidate_status !== "verified" ? <span className="text-grey-medium">Pending Profile</span> : getEnumValue(EARLY_CHILDHOOD_EDUCATION, referrer?.qualification)}
        </div>
      </div>
      <div className="w-170px">{referrer.referrals_count} Referrals</div>
      <div className="d-flex flex-column gap-12 gap-mobile-20">
        {referrer.referees.map((referee) => (
          <RefereeItem
            key={referee.id}
            referee={referee}
            onClick={() => onRefereeClick(referee.uuid, referrer?.id)}
          />
        ))}
      </div>
    </div>
  );
};

export default ReferralCard;
